import { useEnvironmentInterface } from "environment-interface";
import { Badge, ButtonBadge, Tooltip } from "prism-react";

import { useChangelogAvailable } from "hooks/useChangelogAvailable";
import { useEditorUpdate } from "hooks/useEditorUpdate";

export const useEditorUpdateStatusContent = () => {
  const editorUpdate = useEditorUpdate();
  const changelogStatus = useChangelogAvailable();
  const { visibility } = useEnvironmentInterface();

  if (
    !editorUpdate &&
    changelogStatus.status === "available" &&
    !visibility.isInIframe
  ) {
    // Check if we should show changelog notice

    return (
      <Tooltip
        content="Click to see what's new"
        rootProps={{ delayDuration: 0 }}
      >
        <div>
          <ButtonBadge
            icon="chevronRight"
            iconPosition="right"
            iconSize={3}
            onClick={() => {
              changelogStatus.open();
            }}
            variant="accentPrimary"
          >
            CodeSandbox was updated!
          </ButtonBadge>
        </div>
      </Tooltip>
    );
  }

  if (!editorUpdate || editorUpdate.status === "EDITOR_CHECKING_VERSION") {
    return null;
  }

  if (editorUpdate.status === "EDITOR_INSTALLING") {
    return (
      <Tooltip content="It will take a few seconds">
        <div>
          <Badge icon="progress" iconSize={4} variant="neutral">
            Installing editor
          </Badge>
        </div>
      </Tooltip>
    );
  }

  if (editorUpdate.status === "EDITOR_UPDATING") {
    return (
      <Tooltip content="It will take a few seconds">
        <div>
          <Badge icon="progress" iconSize={4} variant="neutral">
            Installing a new editor version
          </Badge>
        </div>
      </Tooltip>
    );
  }

  if (editorUpdate.status === "EDITOR_AND_MICRO_VM_UPDATED") {
    return (
      <Tooltip content="Click to reload the page and update">
        <div>
          <ButtonBadge
            icon="circleBang"
            iconSize={4}
            onClick={editorUpdate.restart}
            variant="accentPrimary"
          >
            Update to latest editor and microVM
          </ButtonBadge>
        </div>
      </Tooltip>
    );
  }

  if (editorUpdate.status === "EDITOR_UPDATED") {
    return (
      <Tooltip content="Click to reload the page and update">
        <div>
          <ButtonBadge
            icon="circleBang"
            iconSize={4}
            onClick={editorUpdate.restart}
            variant="accentPrimary"
          >
            Update to latest editor
          </ButtonBadge>
        </div>
      </Tooltip>
    );
  }

  if (editorUpdate.status === "MICRO_VM_UPDATED") {
    return (
      <Tooltip content="Click to restart microVM">
        <div>
          <ButtonBadge
            icon="circleBang"
            iconSize={4}
            onClick={editorUpdate.restart}
            variant="accentPrimary"
          >
            Update to latest microVM
          </ButtonBadge>
        </div>
      </Tooltip>
    );
  }

  if (editorUpdate.status === "EDITOR_UPDATE_ERROR") {
    return (
      <Tooltip content="Click to reload the page and try again">
        <div>
          <ButtonBadge
            icon="circleBang"
            iconSize={4}
            onClick={editorUpdate.restart}
            variant="error"
          >
            Could not install new version
          </ButtonBadge>
        </div>
      </Tooltip>
    );
  }
};
